<div *ngIf="showDowntimeBanner && getBannerMsg()" class="top-banner">
    <markdown [data]="getBannerMsg()"></markdown>
</div>